import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
	selector: 'lvr-tabs',
	imports: [MatTabsModule],
	templateUrl: './tabs.html',
	styleUrl: './tabs.scss',
})
export class Tabs {}
